import 'css-chunksrc/client/scenes/calendar/navigation/styles.scss';export default {
  "navigation": "_navigation_mxk9z_1"
};